export default "__VITE_ASSET__aochpAE0__"